module.exports = __webpack_public_path__ + "img/129ne.6e15abd7.svg";